(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1566],{

/***/ 14136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectDestructuringEmpty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77191);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92737);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _hooks_useCheckAppVersion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16740);
/* harmony import */ var _comments_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54993);
/* harmony import */ var _comments_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_comments_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);











var CommentsPage = function CommentsPage(_ref) {
  (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectDestructuringEmpty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref);

  (0,_hooks_useCheckAppVersion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var _ref2 = router.query,
      sort = _ref2.sort,
      duration = _ref2.duration;
  var restorationKey = "comment_".concat(sort).concat(duration ? "_".concat(duration) : '');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Head */ .Fb, {
      title: "Comments"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Layout */ .Ar, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_comments_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_comments_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner_container),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_comments_module_scss__WEBPACK_IMPORTED_MODULE_6___default().filter_container),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: (_comments_module_scss__WEBPACK_IMPORTED_MODULE_6___default().filter_sort),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SelectButton */ .UN, {
                active: sort === _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.NEW */ .Tj.NEW,
                onClick: function onClick() {
                  return router.push({
                    pathname: "/comments/[sort]",
                    query: {
                      sort: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.NEW */ .Tj.NEW
                    }
                  }, undefined);
                },
                children: "New"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SelectButton */ .UN, {
                active: sort === _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.VOTE */ .Tj.VOTE,
                onClick: function onClick() {
                  return sort === _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.VOTE */ .Tj.VOTE ? {} : router.push({
                    pathname: "/comments/[sort]",
                    query: {
                      sort: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.VOTE */ .Tj.VOTE,
                      duration: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER_VOTE_OPTION.TODAY */ .bT.TODAY
                    }
                  }, undefined);
                },
                children: "Top"
              })]
            }), sort === _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.VOTE */ .Tj.VOTE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SelectButton.Group */ .UN.Group, {
              items: Object.entries(_constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER_VOTE_OPTION */ .bT).map(function (_ref3) {
                var _ref4 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref3, 2),
                    key = _ref4[0],
                    value = _ref4[1];

                return {
                  key: key,
                  label: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER_VOTE_OPTION_DISPLAY */ .Qv[key],
                  selected: value === duration,
                  value: value
                };
              }),
              onItemClicked: function onItemClicked(clickedItem) {
                return router.push({
                  pathname: "/comments/[sort]",
                  query: {
                    sort: _constants__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_COMMENTS_FILTER.VOTE */ .Tj.VOTE,
                    duration: clickedItem[0].value
                  }
                }, undefined, {
                  shallow: false
                });
              }
            }, duration)]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .GlobalCommentList */ .NS, {
            restorationKey: restorationKey,
            sort: sort,
            duration: duration
          }, restorationKey)]
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CommentsPage);

/***/ }),

/***/ 53727:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comments/[sort]",
      function () {
        return __webpack_require__(14136);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"comments_container__xCFAL","inner_container":"comments_inner_container__jya6F","filter_container":"comments_filter_container__Qx4Qj","filter_sort":"comments_filter_sort__HdbDs"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(53727); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);